export default __webpack_public_path__ + "1636857.png";